import * as yup from 'yup';

export const addProductSchema = yup.object({
	name: yup
		.string()
		.required('Please enter product name!'),
	price: yup
		.number()
		.required('Please enter product price!'),
	countInStock: yup
		.number()
		.required('Please enter count in stock!'),
	brand: yup
		.string()
		.required('Please enter product brand!'),
	rating: yup
		.number()
		.required('Please enter product rating!'),
	numReviews: yup
		.number(),
	colors: yup
		.array()
		.of(yup.string()),
	size: yup
		.array()
		.of(yup.string()),
	availableInLocations: yup
		.string(),
	materialType: yup
		.string(),
	sleeveType: yup
		.string(),
	length: yup
		.string(),
	neckStyle: yup
		.string(),
	style: yup
		.string(),
	countryOfOrigin: yup
		.string()
});
